module.exports = __webpack_public_path__ + "media/images/flags/FJ-b0dff85c5b06f2abd70fb911b4e16157.svg";